<script>
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";

export default {
  name: "DataLogging",
  components: { InformationLayout },
  props: {
    logItem: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    sections() {
      const item = this.logItem;
      const notSpecified = this.$t("Не указано");

      return [
        {
          title: this.$t("Метаданные"),
          items: [
            {
              label: "SessionID",
              values: [{ text: item?.user?.session_id || notSpecified }],
            },
            {
              label: "UserID",
              values: [{ text: item?.id || notSpecified }],
            },
            {
              label: this.$t("Роль пользователя"),
              values: [{ text: item?.user?.role || notSpecified }],
            },
            {
              label: this.$t("Дата и время начала сессии"),
              values: [{ text: item?.timestamp || notSpecified }],
            },
            {
              label: this.$t("Последнее действия пользователя"),
              values: [{ text: item?.timestamp_last || notSpecified }],
            },
            {
              label: this.$t("Время завершения сессии"),
              values: [{ text: item?.timestamp_end || notSpecified }],
            },
            {
              label: this.$t("Причина завершения"),
              values: [{ text: item?.end_session || notSpecified }],
            },
            {
              label: this.$t("IP-адрес пользователя"),
              values: [{ text: item?.ip || notSpecified }],
            },
            {
              label: this.$t("Информация об устройстве"),
              values: [{ text: item?.info || notSpecified }],
            },
            {
              label: this.$t("Географическое местоположение по IP"),
              values: [{ text: item?.locataion || notSpecified }],
            },
            {
              label: this.$t("Метод аутентификации"),
              values: [{ text: item?.methods || notSpecified }],
            },
            {
              label: this.$t("Статус сессии"),
              values: [{ text: item?.status || notSpecified }],
            },
            {
              label: this.$t("Продолжительность сессии в минутах"),
              values: [{ text: item?.time || notSpecified }],
            },
            {
              label: this.$t("Причина завершения"),
              values: [{ text: item?.end || notSpecified }],
            },
            {
              label: this.$t("Вход с нового устройства"),
              values: [{ text: item?.entry || notSpecified }],
            },
            {
              label: this.$t("Уведомления о новом устройстве отправлено"),
              values: [{ text: item?.notif || notSpecified }],
            },
            {
              label: this.$t("Попытка входа с параллельной сессией"),
              values: [{ text: item?.parallel || notSpecified }],
            },
            {
              label: this.$t("Уровень инцидента"),
              values: [{ text: item?.level || notSpecified }],
            },
            {
              label: this.$t("Кто завершил сессию"),
              values: [{ text: item?.who_end || notSpecified }],
            },
            {
              label: this.$t("Ссылка на запись в журнале аудита"),
              values: [{ text: item?.blank || notSpecified }],
            },
          ],
        },
      ];
    },
  },
};
</script>

<template>
  <div class="block">
    <InformationLayout :showHeader="false" :sections="sections" />
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-full overflow-auto bg-white rounded-2xl p-8;
}

@media (max-width: 1400px) {
  .block {
    @apply w-full;
  }
}
</style>
